export default {
  notification: {
    success: {
      disableSharing: 'O compartilhamento do dashboard foi desabilitado com sucesso.',
    },
  },
  label: {
    title: {
      addChart: 'Adicionar componente',
    },
    button: {
      addChart: 'Adicionar',
    },
    chartPerPage: 'Total por página',
    searchCard: 'Buscar componente',
  },
};
